import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import SectionHeading from '@/components/base/SectionHeading';
import { getHotMovies, getLatestMovies, formatViews, getCategoryName } from '@/lib/queries';

export function LatestMovies() {
  const list = getLatestMovies(8);

  return (
    <section className="border-y border-background-800/70 bg-background-900/40">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="Just added"
          title="最新收录影片"
          description="近期进入片单的作品，按收录时间排序。点击封面即可查看完整影片资料与相关推荐。"
          linkTo="/category/drama"
          linkLabel="进入分类页"
        />
        <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-3 md:gap-x-5 lg:grid-cols-4 lg:gap-x-6">
          {list.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}

export function HotRanking() {
  const list = getHotMovies(6);

  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.6fr_1fr] lg:gap-14">
        <div>
          <SectionHeading
            eyebrow="Weekly chart"
            title="热门影片排行榜"
            description="依据站内浏览量排序得出，每日更新，不涉及任何付费推广。"
          />
          <div className="mt-7 divide-y divide-background-800 border-y border-background-800">
            {list.map((movie, index) => (
              <Link
                key={movie.id}
                to={`/detail/${movie.id}`}
                className="group flex cursor-pointer items-center gap-4 py-3.5 transition-colors hover:bg-background-900/60"
              >
                <span
                  className={`w-7 shrink-0 text-center font-label text-xl font-bold ${
                    index < 3 ? 'text-accent-500' : 'text-foreground-700'
                  }`}
                >
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="h-16 w-12 shrink-0 overflow-hidden rounded bg-background-800">
                  <img
                    src={movie.cover}
                    alt={`${movie.title} 封面`}
                    title={`${movie.title} - 日韩成人电影`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-100 transition-colors group-hover:text-accent-400">
                    {movie.title}
                  </p>
                  <p className="mt-1 truncate font-label text-[11px] uppercase tracking-[0.14em] text-foreground-600">
                    {movie.englishTitle}
                  </p>
                  <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
                    <span>{getCategoryName(movie.category)}</span>
                    <span>{movie.region}</span>
                    <span>{movie.year}</span>
                  </div>
                </div>
                <div className="hidden shrink-0 text-right sm:block">
                  <p className="font-label text-sm font-semibold text-accent-400">{movie.rating.toFixed(1)}</p>
                  <p className="mt-0.5 text-[11px] text-foreground-600">{formatViews(movie.views)} 次浏览</p>
                </div>
                <i className="ri-arrow-right-s-line shrink-0 text-lg text-foreground-700 transition-colors group-hover:text-accent-500" />
              </Link>
            ))}
          </div>
        </div>

        <aside className="rounded-lg border border-background-800 bg-background-900 p-5 md:p-6">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
              <i className="ri-award-line text-base" />
            </span>
            <h3 className="text-base font-semibold text-foreground-50">编辑精选</h3>
          </div>
          <p className="mt-3 text-xs leading-relaxed text-foreground-500">
            由编辑从片单中挑选的四部作品，兼顾画面质感与叙事完成度，适合作为第一次浏览的起点。
          </p>
          <div className="mt-5 space-y-4">
            {getHotMovies(4)
              .slice()
              .reverse()
              .map((movie) => (
                <Link key={movie.id} to={`/detail/${movie.id}`} className="group flex cursor-pointer gap-3">
                  <div className="h-[68px] w-[50px] shrink-0 overflow-hidden rounded bg-background-800">
                    <img
                      src={movie.cover}
                      alt={`${movie.title} 封面`}
                      title={`${movie.title} - 日韩成人电影`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 py-0.5">
                    <p className="truncate text-sm text-foreground-200 transition-colors group-hover:text-accent-400">
                      {movie.title}
                    </p>
                    <p className="mt-1 line-clamp-2 text-[11px] leading-relaxed text-foreground-500">{movie.summary}</p>
                  </div>
                </Link>
              ))}
          </div>
          <Link
            to="/tag/%E9%AB%98%E5%88%86%E6%8E%A8%E8%8D%90"
            className="mt-6 inline-flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-md border border-background-700 py-2.5 text-xs text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400"
          >
            查看「高分推荐」标签
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        </aside>
      </div>
    </section>
  );
}